import { defineComponent } from 'vue';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import { mapState } from 'pinia';
import ResultTestExample from '@/assets/covid/example-test.png';
import ButtonListNetflix from '@/components/ButtonListNetflix/ButtonListNetflix.vue';
import {
  ExamResultInterface,
  NegativeWithoutSymptons,
  NegativeWithSymptons,
  PositiveWithoutSymptons,
  PositiveWithSymptons,
} from '@/constants/ExamResults';

import {
  ExamResultInterface as ExamResultInterfaceHiv,
  Positive,
  NegativeOverThirtyDays,
  NegativeUntilThreeDays,
  NegativeWithInterval,
  InvalidOverThirtyDays,
  InvalidUntilThreeDays,
  InvalidWithInterval,
} from '@/constants/ExamResultsHiv';

import ThemesHelper from '@/helpers/ThemesHelper';

export default defineComponent({
  components: {
    ButtonListNetflix,
  },
  computed: {
    ...mapState(useRegisterTestStore, ['patient']),
    ...mapState(useRegisterTestStore, ['exposureTime']),
    ...mapState(useRegisterTestStore, ['testImage']),
    ...mapState(useRegisterTestStore, ['testSymptoms']),
    ...mapState(useRegisterTestStore, ['resultTest']),
  },
  data() {
    return {
      testType: '',
      resultTestExampleImage: ResultTestExample,
      resultInfos: {} as ExamResultInterface,
      resultInfosHiv: {} as ExamResultInterfaceHiv,
      testName: ThemesHelper.getThemeParams('testName'),
      registerTestStore: useRegisterTestStore(),
      ageMsg:
        'Autoteste realizado para menor de idade. O usuário declara que o teste foi realizado com supervisão ou ajuda do adulto responsável. O autoteste não configura um exame laboratorial e esse cartão de resultado não tem valor legal e nem de laudo oficial. Para os casos de laudo para viagens, atestados de trabalho, eventos ou outro fim comprobatório, deve-se procurar uma farmácia para realizar o teste com um profissional da saúde.',
      testMsg:
        ' O autoteste não configura um exame laboratorial e esse cartão de resultado não tem valor legal e nem de laudo oficial. Para os casos de laudo para viagens, atestados de trabalho, eventos ou outro fim comprobatório, deve-se procurar uma farmácia para realizar o teste com um profissional da saúde.',
      ageMsgHiv:
        'Este resultado é relativo a declaração registrada pelo próprio paciente que realizou o teste. O autoteste não configura um exame laboratorial e esse cartão de resultado não tem valor legal e nem de laudo oficial.  Autoteste realizado para menor de 12 anos. O usuário declara que o  teste foi realizado com supervisão ou ajuda do adulto responsável.',
      testMsgHiv:
        'Este resultado é relativo a declaração registrada pelo próprio paciente que realizou o teste. O autoteste não configura um exame laboratorial e esse cartão de resultado não tem valor legal e nem de laudo oficial.      ',
    };
  },
  mounted() {
    if (this.testName === 'Autoteste HIV-1/2 Sure Check') {
      this.testType = 'hiv';
      this.initResultVars();
    } else {
      this.setExamInfos();
    }
  },
  methods: {
    cpfMask() {
      const patientData = { ...this.registerTestStore.patient };
      const cpfPatient = patientData.document || '';
      const patientCpfMask = cpfPatient.replace(
        /(\d{3}).(\d{3}).(\d{3}).(\d{2})/,
        '***.***.***-$4'
      );
      return patientCpfMask;
    },

    agePatient() {
      const patientBirthdate = { ...this.registerTestStore.patient };
      let data = patientBirthdate.birthdate?.replace(/\//g, '-');
      const data_array = data?.split('-');

      if (data_array?.[0].length != 4) {
        data = data_array?.[2] + '-' + data_array?.[1] + '-' + data_array?.[0];
      }

      const today = new Date();
      const birth = new Date(data);
      let age = today.getFullYear() - birth.getFullYear();
      const month = today.getMonth() - birth.getMonth();
      if (month < 0 || (month === 0 && today.getDate() <= birth.getDate()))
        age--;

      if (this.testType !== 'hiv') {
        if (today.getFullYear() < birth.getFullYear()) {
          return this.ageMsg;
        }
        if (age < 14) {
          return this.ageMsg;
        } else {
          return this.testMsg;
        }
      } else {
        if (this.patient.age < 12) {
          return this.ageMsgHiv;
        } else {
          return this.testMsgHiv;
        }
      }
    },

    getCurrentDate(): string {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();

      return day + '/' + month + '/' + year;
    },

    setHivContactDays(resultTest: string): ExamResultInterfaceHiv {
      switch (resultTest) {
        case 'negative':
          if (this.exposureTime === 'until_three_days') {
            return NegativeUntilThreeDays;
          }
          if (this.exposureTime === 'between_four_and_twenty_nine') {
            return NegativeWithInterval;
          }
          if (this.exposureTime === 'thirty_days_or_more') {
            return NegativeOverThirtyDays;
          }
          break;
        case 'invalid':
          if (this.exposureTime === 'until_three_days') {
            return InvalidUntilThreeDays;
          }
          if (this.exposureTime === 'between_four_and_twenty_nine') {
            return InvalidWithInterval;
          }
          if (this.exposureTime === 'thirty_days_or_more') {
            return InvalidOverThirtyDays;
          }
          break;
        default:
          return {} as ExamResultInterfaceHiv;
      }
      return {} as ExamResultInterfaceHiv;
    },

    initResultVars() {
      let imageResult = '';
      switch (this.resultTest) {
        case 'positive':
          this.resultInfosHiv = Positive;
          imageResult = 'urlPositiveImage';
          break;
        case 'negative':
          this.resultInfosHiv = this.setHivContactDays('negative');
          imageResult = 'urlNegativeImage';
          break;
        case 'invalid_one_line':
          this.resultInfosHiv = this.setHivContactDays('invalid');
          imageResult = 'urlInvalidOneLineImage';
          break;
        case 'invalid_no_line':
          this.resultInfosHiv = this.setHivContactDays('invalid');
          imageResult = 'urlInvalidNoLineImage';
          break;
      }

      this.resultInfos.imageResult = ThemesHelper.getUrlImage(imageResult);
    },

    setExamInfos() {
      if (this.resultTest == 'positive') {
        this.resultInfos =
          this.testSymptoms == 'yes'
            ? PositiveWithSymptons
            : PositiveWithoutSymptons;
      } else {
        this.resultInfos =
          this.testSymptoms == 'yes'
            ? NegativeWithSymptons
            : NegativeWithoutSymptons;
      }
    },
  },
});
